import { createFileRoute, redirect } from '@tanstack/react-router';

import { can, sessionQuery } from '@/shared/auth';

/** Home: operations people start in My work, everyone else on the dashboard. */
export const Route = createFileRoute('/_app/')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.query({ ...sessionQuery, staleTime: 'static' });
    const opsFirst =
      can(session, 'operations.update') &&
      !can(session, 'collection.view') &&
      !can(session, 'config.edit');
    throw redirect({ to: opsFirst ? '/my-work' : '/dashboard' });
  },
});
